var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocument24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M8 14.001h8M8 18h5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M4 4a2 2 0 0 1 2-2h3.421a3 3 0 0 1 3 3v2.5a2.5 2.5 0 0 0 2.5 2.5H17a3 3 0 0 1 3 3v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M4 4a2 2 0 0 1 2-2h3.234a8 8 0 0 1 6.12 2.847l2.765 3.285A8 8 0 0 1 20 13.285V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
})));
export default SvgDocument24Px;